import { stats, topicRank } from "@/mocks/baoliao";

const deltaIcon: Record<string, { icon: string; cls: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "text-primary-600 bg-primary-100" },
  down: { icon: "ri-arrow-down-line", cls: "text-accent-700 bg-accent-100" },
  new: { icon: "ri-flashlight-fill", cls: "text-foreground-900 bg-secondary-200" },
  flat: { icon: "ri-subtract-line", cls: "text-foreground-600 bg-background-200" },
};

export default function Topics() {
  return (
    <section id="topics" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {/* 左：热议榜单 */}
          <div className="lg:col-span-7">
            <div className="flex items-end justify-between mb-5">
              <div>
                <p className="text-xs text-primary-600 font-medium tracking-widest uppercase">HOT TOPICS</p>
                <h2 className="mt-1 text-2xl md:text-3xl text-foreground-950">今日热议话题</h2>
              </div>
              <span className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-primary-100 text-primary-800 px-3 py-1 text-xs whitespace-nowrap">
                <i className="ri-timer-flash-line" />
                每小时更新
              </span>
            </div>

            <div className="rounded-xl bg-background-100 border border-background-200/60 divide-y divide-background-200/60 overflow-hidden">
              {topicRank.map((t) => {
                const d = deltaIcon[t.delta];
                return (
                  <a
                    key={t.rank}
                    href="#feed"
                    className="flex items-center gap-4 px-5 py-4 hover:bg-background-200/40 transition-colors group"
                  >
                    <span
                      className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-lg text-base font-bold ${
                        t.rank === 1
                          ? "bg-primary-600 text-background-50"
                          : t.rank === 2
                          ? "bg-accent-500 text-foreground-950"
                          : t.rank === 3
                          ? "bg-secondary-300 text-foreground-900"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {t.rank}
                    </span>
                    <p className="flex-1 text-[15px] text-foreground-900 group-hover:text-primary-700 transition-colors whitespace-nowrap overflow-hidden text-ellipsis">
                      {t.title}
                    </p>
                    <span className="hidden md:inline-flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
                      <i className="ri-fire-fill text-accent-500" />
                      热度 {t.hot}
                    </span>
                    <span
                      className={`inline-flex w-6 h-6 items-center justify-center rounded-full text-xs ${d.cls}`}
                    >
                      <i className={d.icon} />
                    </span>
                  </a>
                );
              })}
            </div>
          </div>

          {/* 右：数据口碑 */}
          <div className="lg:col-span-5">
            <div className="rounded-xl bg-foreground-950 text-background-50 p-6 md:p-7 h-full flex flex-col">
              <h3 className="text-lg md:text-xl text-background-50 leading-snug">
                为什么 380万+ 读者
                <br />
                每天都在这里吃瓜？
              </h3>
              <div className="mt-6 grid grid-cols-2 gap-4">
                {stats.map((s) => (
                  <div key={s.label} className="rounded-lg bg-foreground-900 p-4">
                    <p className="text-2xl md:text-3xl text-accent-400 font-bold" style={{ fontFamily: "var(--font-heading)" }}>
                      {s.value}
                    </p>
                    <p className="text-xs text-background-100/70 mt-1">{s.label}</p>
                  </div>
                ))}
              </div>
              <div className="mt-auto pt-6">
                <div className="rounded-lg bg-accent-500 p-4 text-foreground-950">
                  <p className="text-sm leading-relaxed">
                    “追了大半年，呱呱爆料的线索梳理几乎没让我失望，先报后核，节奏很舒服。”
                  </p>
                  <p className="text-xs mt-2 font-medium">—— 读者 老瓜农（昵称）</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}